$(document).ready(function () {

  var current_url = window.location.href;
  var split_url = current_url.split('form_type=');
  if(split_url[1] == 'customer#ContactFooter'){
    $('.newsletter-already_subscribe_email').html('Email Already Registered!')
  }else{
    $('.newsletter-already_subscribe_email').hide();
  }
  
  $(document).on("click",".announcement-bar-close",function() {
      $(".announcement-bar-sections-div").hide();
      $(this).hide();
  });
    
  $(".single-slider .slide-list").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

    $('.collection-tab-slider-list').slick({
    arrows: true,
    infinite: true,
    dots: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
     {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  
 $('.product-slider .product-list').slick({
    dots: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

     $('.collection-product-slider .collection-product-list').slick({
    arrows: true,
    infinite: false,
    dots: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

 $('.customer-slider .customer_list').slick({
    dots: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  



  

// setTimeout(function() {
//   $(".topHeaderTabs ul li").eq(0).click(); 
// }, 3000);

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
  $('.collection-tab-slider-list').slick('refresh');
  $('.collection-product-slider .collection-product-list').slick('refresh');
  
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  $('.collection-tab-slider-list').slick('refresh');
  $('.collection-product-slider .collection-product-list').slick('refresh');
  
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");



  
});



